import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';
import { getIsPadWidth } from '@elem/utils/devices';
import EFPicture from 'elem/compCommon/EFPicture';
import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartItem } from 'eco-design/elements/eco-cart/type.d';
import gtm from 'eco-design-reliance/gtm';

export default function M() {
    const { useLang, useState, useEffect, useRouter, Link } = useGlobal();
    const { t } = useLang('vanliferoadtrips');
    const { locale } = useRouter();

    const isMobile = getIsPadWidth(); //是否是移动端
    const cards: any = [
        {
            img: '',
            title: t('secM_card1_title'),
            sort: 1,
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/ecoflow-wave-3-portable-air-conditioner-with-heater',
                    ca: 'https://ca.ecoflow.com/products/ecoflow-wave-3-portable-air-conditioner-with-heater',
                    de: 'https://de.ecoflow.com/products/wave-3-portable-air-conditioner',
                    za: 'https://za.ecoflow.com/products/ecoflow-wave-portable-air-conditioner',
                    fr: 'https://fr.ecoflow.com/products/wave-3-portable-air-conditioner',
                    eu: 'https://eu.ecoflow.com/products/wave-3-portable-air-conditioner',
                    uk: 'https://uk.ecoflow.com/products/wave-3-portable-air-conditioner',
                    it: 'https://it.ecoflow.com/products/wave-3-portable-air-conditioner',
                    es: 'https://es.ecoflow.com/products/wave-3-portable-air-conditioner',
                    nl: 'https://nl.ecoflow.com/products/wave-3-portable-air-conditioner',
                    au: 'https://au.ecoflow.com/products/wave-2-portable-air-conditioner',
                    kr: 'https://kr.ecoflow.com/products/wave-2-portable-air-conditioner',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7414779576393',
                    ca: '15052470157683',
                    de: '15217984766333',
                    za: '7155609665745',
                    fr: '9890446508379',
                    eu: '10031577006423',
                    uk: '9901733773651',
                    it: '14924082217336',
                    es: '9890449949019',
                    au: '7795796410566',
                    kr: '7737145655465',
                    nl: '9935712583956',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '42093673021513',
                    ca: '52405151662451',
                    de: '55989433500029',
                    za: '41347453386961',
                    fr: '50546212831579',
                    eu: '50625391624535',
                    uk: '50942834639187',
                    it: '55112949301624',
                    es: '50546220106075',
                    au: '42713053593798',
                    kr: '43039193956521',
                    nl: '51194422591764',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secM_card1_desc1'), t('secM_card1_desc2'), t('secM_card1_desc3'), t('secM_card1_desc4'), t('secM_card1_desc5')],
        },
        {
            showGoodDesign: !!['au'].includes(locale),
            img: '',
            title: t('secM_card2_title'),
            sort: 2,
            // tag: ZA_SITE.includes(locale) ? t('common_card_tag_coming_soon') : '',
            // za站的glacier没有对应的shopify产品，跳转官网glacier预热页
            // notShopifySites: ['za'],
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/ecoflow-glacier-classic-55l-portable-fridge-freezer',
                    ca: 'https://ca.ecoflow.com/products/ecoflow-glacier-classic-55l-portable-fridge-freezer',
                    de: 'https://de.ecoflow.com/products/glacier-classic-portable-fridge-freezer',
                    za: 'https://za.ecoflow.com/products/glacier-portable-refrigerator',
                    fr: 'https://fr.ecoflow.com/products/glacier-classic-portable-fridge-freezer',
                    eu: 'https://eu.ecoflow.com/products/glacier-classic-portable-fridge-freezer',
                    uk: 'https://uk.ecoflow.com/products/glacier-classic-portable-fridge-freezer',
                    it: 'https://it.ecoflow.com/products/glacier-classic-portable-fridge-freezer',
                    es: 'https://es.ecoflow.com/products/glacier-classic-portable-fridge-freezer',
                    nl: 'https://nl.ecoflow.com/products/glacier-classic-portable-fridge-freezer',
                    au: 'https://au.ecoflow.com/products/glacier-portable-refrigerator',
                    kr: 'https://kr.ecoflow.com/products/glacier-portable-refrigerator',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7414796615753',
                    ca: '15052472680819',
                    de: '15239186121085',
                    fr: '9910142468443',
                    eu: '10049921941847',
                    uk: '9918374084947',
                    it: '14928772137336',
                    es: '9910143287643',
                    za: '7322399834321',
                    au: '7795792412870',
                    kr: '7738246856873',
                    nl: '9935713468692',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '42093744685129',
                    ca: '52405173059955',
                    de: '56053796438397',
                    fr: '50609009099099',
                    eu: '50706357059927',
                    uk: '51023557689683',
                    it: '55137015202168',
                    es: '50609010704731',
                    za: '41834564452561',
                    au: '42713036128454',
                    kr: '43039330369705',
                    nl: '51194425409812',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secM_card2_desc1'), t('secM_card2_desc2'), t('secM_card2_desc3'), t('secM_card2_desc4'), t('secM_card2_desc5')],
        },
    ];

    if (locale === 'au') {
        cards[0].descArr.push(t('secM_card1_desc6'));
    }

    const [cardLists, setCardLists] = useState(cards);

    const handleBuy = (card: any) => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'bundle_add_to_cart',
                list_name: card?.title || card?.productTitle || card?.skuTitle,
                product_name: card?.title || card?.productTitle || card?.skuTitle,
                price: card?.price,
                tag: card?.tag || 'none',
                quantity: 1,
                button_name: t('common_card_buy') || 'Buy Now',
            });
            // @ts-ignore
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {
            const { price, compareAtPrice, inventoryPolicy, inventoryQuantity, productId, variantId, variantImg, img, productTitle, skuTitle } = card;
            EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, [
                {
                    price,
                    compareAtPrice,
                    inventoryPolicy,
                    inventoryQuantity,
                    productId,
                    variantId,
                    variantImg,
                    img,
                    productTitle,
                    skuTitle,
                    quantity: 1,
                } as ItfEcoCartItem,
            ]);
        }
    };

    useEffect(() => {
        const tempArr = [...cards.filter((card: any) => !card?.notShopifySites?.includes(locale))];
        const otherArr = [...cards.filter((card: any) => card?.notShopifySites?.includes(locale))];
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        if (res?.data?.handle) {
                            tempArr[k].link_more = `https://${locale}.ecoflow.com/products/${res?.data?.handle}?variant=${variantId}`;
                        }
                        tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                        return resolve({ ...tempArr?.[k], ...res?.data });
                    } else {
                        console.error(res?.message);
                        return reject({ ...tempArr?.[k] });
                    }
                } catch (e) {
                    console.error(e);
                    return reject({ ...tempArr?.[k] });
                }
            });
        };
        const promises = tempArr?.map((item: any, k: number) => getAsynItem(item?.productId, item.variantId, k));
        Promise.all(promises)
            .then((res: any) => {
                setCardLists(res);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    return (
        <div id="vanlife-roadtrips-M" className={`vanlife-roadtrips-M ${css['vanlife-roadtrips-M']}`}>
            <div className="ef-box">
                <Swiper
                    className="cards swiper-box"
                    effect="fade"
                    spaceBetween={16}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    modules={[Scrollbar]}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                    allowTouchMove={isMobile}
                >
                    {cardLists?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                            {card?.tag && <span className="card-tag">{card?.tag}</span>}
                            {card?.showGoodDesign && (
                                <div className="card-good-design">
                                    <EFPicture src="/responsive/picture/good_design.png" alt={card?.title} />
                                </div>
                            )}
                            <div className="card-img">
                                <EFPicture src={card?.variantImg || card?.img} alt={card?.title || card?.productTitle || card?.skuTitle} />
                            </div>
                            <div className="card-info">
                                <p className="card-title">{card?.title || card?.productTitle || card?.skuTitle}</p>
                                <ul className="card-descs">
                                    {card?.descArr?.map((desc: any, m: number) => (
                                        <li className="card-desc" key={`${k}_${m}`}>
                                            {desc}
                                        </li>
                                    ))}
                                </ul>
                                <div className="card-btns">
                                    {card?.link_buy && locale === 'kr' ? (
                                        <div className="card-btn-cart">
                                            <button
                                                className={`kr-shop${
                                                    Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'continue' ? ' disabled' : ''
                                                }`}
                                                onClick={() =>
                                                    (Number(card?.inventoryQuantity || 0) > 0 || card?.inventoryPolicy === 'continue') &&
                                                    window.open(card?.link_buy, '_blank')
                                                }
                                            >
                                                {t('common_card_buy_new')}
                                            </button>
                                            <button
                                                className={`kr-add-cart${
                                                    Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'continue' ? ' disabled' : ''
                                                }`}
                                                onClick={() =>
                                                    (Number(card?.inventoryQuantity || 0) > 0 || card?.inventoryPolicy === 'continue') && handleBuy(card)
                                                }
                                            >
                                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M16.1665 20C16.1665 21.3807 17.2858 22.5 18.6665 22.5C20.0472 22.5 21.1664 21.3807 21.1664 20C21.1664 18.6193 20.0472 17.5 18.6665 17.5C17.2858 17.5 16.1665 18.6193 16.1665 20ZM19.7056 20.017C19.7056 20.5692 19.2579 21.017 18.7057 21.017C18.1534 21.017 17.7057 20.5692 17.7057 20.017C17.7057 19.4647 18.1534 19.017 18.7057 19.017C19.2579 19.017 19.7056 19.4647 19.7056 20.017Z"
                                                        fill="currentColor"
                                                    ></path>
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M6.1665 20C6.1665 21.3807 7.28578 22.5 8.66647 22.5C10.0472 22.5 11.1664 21.3807 11.1664 20C11.1664 18.6193 10.0472 17.5 8.66647 17.5C7.28578 17.5 6.1665 18.6193 6.1665 20ZM9.70565 20.017C9.70565 20.5692 9.25794 21.017 8.70566 21.017C8.15339 21.017 7.70568 20.5692 7.70568 20.017C7.70568 19.4647 8.15339 19.017 8.70566 19.017C9.25794 19.017 9.70565 19.4647 9.70565 20.017Z"
                                                        fill="currentColor"
                                                    ></path>
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M21.1664 6.66667H7.44731L7.18443 4.67432C7.02155 3.432 5.96318 2.5019 4.70956 2.5H2.83332C2.37309 2.5 2 2.8731 2 3.33333C2 3.79357 2.37309 4.16667 2.83332 4.16667H4.70829C5.12491 4.1673 5.4777 4.47733 5.53202 4.89167L6.79876 14.4923C6.96283 15.7441 8.0355 16.6774 9.29863 16.6666L18.0998 16.6667C19.2946 16.6897 20.3479 15.8418 20.5838 14.654L21.9835 7.66362C22.0868 7.1479 21.6923 6.66667 21.1664 6.66667ZM8.45117 14.275L7.66721 8.33333H20.1497L18.9493 14.328C18.8704 14.7252 18.5193 15.0079 18.1157 15.0002L9.29156 15C8.86345 15.0036 8.5059 14.6925 8.45117 14.275Z"
                                                        fill="currentColor"
                                                    ></path>
                                                    <path
                                                        d="M14.5 9.5C14.5 9.22386 14.2761 9 14 9C13.7239 9 13.5 9.22386 13.5 9.5V11H12C11.7239 11 11.5 11.2239 11.5 11.5C11.5 11.7761 11.7239 12 12 12H13.5V13.5C13.5 13.7761 13.7239 14 14 14C14.2761 14 14.5 13.7761 14.5 13.5V12H16C16.2761 12 16.5 11.7761 16.5 11.5C16.5 11.2239 16.2761 11 16 11H14.5V9.5Z"
                                                        fill="currentColor"
                                                        stroke="currentColor"
                                                        stroke-width="0.3"
                                                    ></path>
                                                </svg>
                                            </button>
                                        </div>
                                    ) : (
                                        card?.link_buy && (
                                            <>
                                                {Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'continue' ? (
                                                    <button disabled className={`btn-buy card-btn disable`}>
                                                        {t('common_card_out')}
                                                    </button>
                                                ) : (
                                                    <p className={`btn-buy card-btn`} onClick={() => handleBuy(card)}>
                                                        {t('common_card_buy')}
                                                    </p>
                                                )}
                                            </>
                                        )
                                    )}
                                    {card?.link_more && (
                                        <Link
                                            className="btn-more card-btn"
                                            href={
                                                ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'].includes(locale)
                                                    ? card?.link_more
                                                    : `${card?.link_more}${
                                                          String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                                      }utm_source=scenario+page&utm_medium=Pillar`
                                            }
                                            target="_blank"
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'select_product',
                                                list_name: t('secM_title'),
                                                product_name: card.title,
                                                button_name: t('common_card_more'),
                                            }}
                                        >
                                            {t('common_card_more')}
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
